/* ============================================================
   KRAVE / WORLDWIDE  //  krave.js
   Vanilla. No jQuery. Progressive. Sold out is sold out.

   Copyright KRAVE WORLDWIDE. All rights reserved.
   Designed and produced by KRAVE WORLDWIDE.
   Unauthorised copying, reuse, or redistribution is prohibited.
   ============================================================ */
(function(){
  "use strict";

  /* ---- console signature ----------------------------------- */
  try{
    console.log("%cKRAVE WORLDWIDE","font:700 22px Georgia,serif;font-style:italic;color:#E5091A;");
    console.log("%cSite designed and produced by KRAVE WORLDWIDE. Proprietary. Unauthorised copying or reuse is prohibited.","font:12px monospace;color:#E8E0D6;letter-spacing:.1em;");
  }catch(e){}

  var KRAVE = window.KRAVE = window.KRAVE || {};
  var money = (typeof window.Shopify !== "undefined" && Shopify.currency) ? Shopify.currency.active : "AUD";

  /* ---- helpers ------------------------------------------- */
  function $(s,c){return (c||document).querySelector(s);}
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function on(el,ev,fn){if(el)el.addEventListener(ev,fn);}
  function fmt(cents){
    var v=(cents/100);
    try{return new Intl.NumberFormat(undefined,{style:"currency",currency:money}).format(v);}
    catch(e){return "$"+v.toFixed(2);}
  }
  function toast(msg){
    var t=$("#krave-toast");
    if(!t){t=document.createElement("div");t.id="krave-toast";t.className="toast";document.body.appendChild(t);}
    t.textContent=msg;t.classList.add("is-on");
    clearTimeout(t._k);t._k=setTimeout(function(){t.classList.remove("is-on");},2200);
  }
  KRAVE.toast=toast;KRAVE.fmt=fmt;

  /* ---- 1. MARQUEE: clone track to seamless loop ---------- */
  function initMarquee(){
    $$(".marquee").forEach(function(m){
      var track=m.querySelector(".marquee__track");
      if(!track||track.dataset.cloned)return;
      var clone=track.cloneNode(true);clone.setAttribute("aria-hidden","true");
      m.appendChild(clone);track.dataset.cloned="1";
    });
  }

  /* ---- 2. MOBILE NAV ------------------------------------- */
  function initNav(){
    var panel=$("#nav-panel");
    function open(){if(panel){panel.classList.add("is-open");document.documentElement.style.overflow="hidden";}}
    function close(){if(panel){panel.classList.remove("is-open");document.documentElement.style.overflow="";}}
    $$("[data-nav-open]").forEach(function(b){on(b,"click",open);});
    $$("[data-nav-close]").forEach(function(b){on(b,"click",close);});
    on(document,"keydown",function(e){if(e.key==="Escape")close();});
  }

  /* ---- 3. CART DRAWER ------------------------------------ */
  var Cart=KRAVE.cart={
    open:function(){var d=$("#cart-drawer"),s=$("#drawer-scrim");if(d)d.classList.add("is-open");if(s)s.classList.add("is-open");document.documentElement.style.overflow="hidden";},
    close:function(){var d=$("#cart-drawer"),s=$("#drawer-scrim");if(d)d.classList.remove("is-open");if(s)s.classList.remove("is-open");document.documentElement.style.overflow="";},
    refresh:function(){
      return fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(function(c){Cart.render(c);return c;});
    },
    render:function(c){
      $$("[data-cart-count]").forEach(function(el){el.textContent=c.item_count;el.classList.toggle("krave-hidden",c.item_count===0);});
      var body=$("#cart-lines"),foot=$("#cart-foot"),empty=$("#cart-empty");
      if(!body)return;
      if(c.item_count===0){body.innerHTML="";if(empty)empty.classList.remove("krave-hidden");if(foot)foot.classList.add("krave-hidden");return;}
      if(empty)empty.classList.add("krave-hidden");if(foot)foot.classList.remove("krave-hidden");
      body.innerHTML=c.items.map(function(it){
        var img=it.image?it.image.replace(/(\.[a-z]+)(\?.*)?$/i,"_160x$1$2"):"";
        var opts=(it.options_with_values||[]).map(function(o){return o.value;}).filter(function(v){return v&&v!=="Default Title";}).join(" / ");
        return '<div class="cart-line" data-key="'+it.key+'">'+
          '<a class="cart-line__media" href="'+it.url+'">'+(img?'<img src="'+img+'" alt="'+it.product_title+'">':'')+'</a>'+
          '<div><a href="'+it.url+'" class="cart-line__name">'+it.product_title+'</a>'+
          (opts?'<div class="cart-line__opt">'+opts+'</div>':'')+
          '<div class="qty"><button data-qty="-" aria-label="Decrease">-</button>'+
          '<input type="text" value="'+it.quantity+'" data-qty-input readonly aria-label="Quantity"><button data-qty="+" aria-label="Increase">+</button></div>'+
          '<button class="cart-line__remove" data-remove>Remove</button></div>'+
          '<div class="cart-line__price">'+fmt(it.final_line_price)+'</div></div>';
      }).join("");
      var tot=$("#cart-total");if(tot)tot.textContent=fmt(c.total_price);
    },
    change:function(key,qty){
      return fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(function(c){Cart.render(c);return c;});
    },
    add:function(id,qty,btn){
      if(btn){btn.disabled=true;btn.dataset.label=btn.textContent;btn.textContent="Adding";}
      return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({id:id,quantity:qty||1})}).then(function(r){
          if(!r.ok)return r.json().then(function(e){throw e;});return r.json();
        }).then(function(){
          if(btn){btn.disabled=false;btn.textContent=btn.dataset.label||"Add";}
          return Cart.refresh();
        }).then(function(){Cart.open();}).catch(function(e){
          if(btn){btn.disabled=false;btn.textContent=btn.dataset.label||"Add";}
          toast((e&&e.description)?e.description:"Sold out is sold out");
        });
    }
  };

  function initCart(){
    $$("[data-cart-open]").forEach(function(b){on(b,"click",function(e){e.preventDefault();Cart.open();});});
    $$("[data-cart-close]").forEach(function(b){on(b,"click",Cart.close);});
    on($("#drawer-scrim"),"click",Cart.close);
    on(document,"keydown",function(e){if(e.key==="Escape")Cart.close();});

    // delegated qty + remove inside drawer
    on($("#cart-lines"),"click",function(e){
      var line=e.target.closest(".cart-line");if(!line)return;var key=line.dataset.key;
      if(e.target.matches("[data-qty]")){
        var input=line.querySelector("[data-qty-input]");var q=parseInt(input.value,10)||1;
        q=e.target.dataset.qty==="+"?q+1:Math.max(0,q-1);Cart.change(key,q);
      }
      if(e.target.matches("[data-remove]")){Cart.change(key,0);}
    });

    // ajax add buttons (PDP + quick add)
    $$("form[data-product-form]").forEach(function(form){
      on(form,"submit",function(e){
        e.preventDefault();
        var id=form.querySelector('[name="id"]').value;
        var qtyEl=form.querySelector('[name="quantity"]');
        var qty=qtyEl?parseInt(qtyEl.value,10):1;
        var btn=form.querySelector('[type="submit"]');
        Cart.add(id,qty,btn);
      });
    });
    Cart.refresh();
  }

  /* ---- 4. PDP VARIANTS + SOLD-OUT/ATC OBSERVER ----------- */
  function initVariants(){
    $$("[data-variant-root]").forEach(function(root){
      var data=root.querySelector("[data-variant-json]");
      if(!data)return;
      var variants=JSON.parse(data.textContent);
      var form=root.querySelector("form[data-product-form]");
      var idField=form?form.querySelector('[name="id"]'):null;
      var atc=form?form.querySelector('[data-atc]'):null;
      var soldBtn=root.querySelector('[data-sold-out]');   // inline display:none default
      var priceEl=root.querySelector('[data-price]');
      var wasEl=root.querySelector('[data-price-was]');

      function selected(){
        var groups=$$("[data-opt]",root);
        if(!groups.length){return variants.find(function(v){return v.available;})||variants[0];}
        var opts=groups.map(function(g){
          var c=g.querySelector("input:checked");return c?c.value:null;
        });
        return variants.find(function(v){
          return v.options.every(function(o,i){return o===opts[i];});
        });
      }
      var qInput=form?form.querySelector('[data-qty-val]'):null;
      var qDec=form?form.querySelector('[data-qty-dec]'):null;
      var qInc=form?form.querySelector('[data-qty-inc]'):null;
      var qMax=Infinity;
      function clampQty(){
        if(!qInput)return;
        var n=parseInt(qInput.value,10)||1;
        if(n<1)n=1;if(n>qMax)n=qMax;
        qInput.value=n;
        if(qDec)qDec.disabled=n<=1;
        if(qInc)qInc.disabled=n>=qMax;
      }
      if(qDec)on(qDec,"click",function(){if(qInput){qInput.value=(parseInt(qInput.value,10)||1)-1;clampQty();}});
      if(qInc)on(qInc,"click",function(){if(qInput){qInput.value=(parseInt(qInput.value,10)||1)+1;clampQty();}});
      function update(){
        var v=selected();
        if(!v){return;}
        if(idField)idField.value=v.id;
        if(priceEl)priceEl.textContent=fmt(v.price);
        if(wasEl){if(v.compare_at_price&&v.compare_at_price>v.price){wasEl.textContent=fmt(v.compare_at_price);wasEl.classList.remove("krave-hidden");}else{wasEl.classList.add("krave-hidden");}}
        // disable unavailable option values (basic, single-option-aware)
        if(v.available){
          if(soldBtn)soldBtn.style.display="none";
        }else{
          if(soldBtn)soldBtn.style.display="flex";
        }
        qMax=(typeof v.max==="number")?v.max:Infinity;
        clampQty();
      }
      $$("[data-opt] input",root).forEach(function(i){on(i,"change",update);});
      update();

      // Observer pattern carried over from prior build:
      // watch sold-out button display, toggle krave-hidden on ATC wrap.
      if(soldBtn&&atc){
        var wrap=form.querySelector(".pdp__buy")||atc.closest("[data-atc-wrap]")||atc;
        var sync=function(){
          var hidden=soldBtn.style.display==="none";
          wrap.classList.toggle("krave-hidden",!hidden);
          soldBtn.classList.toggle("krave-hidden",hidden);
        };
        new MutationObserver(sync).observe(soldBtn,{attributes:true,attributeFilter:["style"]});
        sync();
      }
    });
  }

  /* ---- 5. INFINITE SCROLL (collection) ------------------- */
  function initInfinite(){
    var sentinel=$("#infinite-sentinel");
    var grid=$("#collection-grid");
    if(!sentinel||!grid)return;
    var loader=$("[data-infinite-loader]");
    var next=sentinel.dataset.next||"";
    var loading=false;
    if(!next){sentinel.remove();return;}
    function showLoader(){if(loader)loader.hidden=false;}
    function hideLoader(){if(loader)loader.hidden=true;}
    function endLoader(){
      if(!loader)return;
      loader.hidden=false;loader.classList.add("is-end");
      var lab=loader.querySelector(".infinite-loader__label");
      if(lab)lab.textContent="End of the archive";
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting&&!loading&&next){
          loading=true;showLoader();
          var started=Date.now();
          fetch(next).then(function(r){return r.text();}).then(function(html){
            var doc=new DOMParser().parseFromString(html,"text/html");
            var more=doc.querySelector("#collection-grid");
            var sent=doc.querySelector("#infinite-sentinel");
            var append=function(){
              if(more){
                var kids=Array.prototype.slice.call(more.children);
                kids.forEach(function(ch,i){
                  if(ch.classList)ch.classList.remove("in");
                  grid.appendChild(ch);
                  if(ch.hasAttribute&&ch.hasAttribute("data-reveal")){
                    (function(el,idx){setTimeout(function(){el.classList.add("in");},30+idx*45);})(ch,i);
                  }
                });
              }
              next=sent?(sent.dataset.next||""):"";
              sentinel.dataset.next=next;loading=false;
              if(!next){io.disconnect();endLoader();}else{hideLoader();}
              bindQuickAdd();
              document.dispatchEvent(new CustomEvent("krave:gridupdated"));
            };
            // keep the loader visible briefly so it reads as intentional, not a flash
            var wait=Math.max(0,360-(Date.now()-started));
            setTimeout(append,wait);
          }).catch(function(){loading=false;hideLoader();});
        }
      });
    },{rootMargin:"600px"});
    io.observe(sentinel);
  }

  /* ---- FILTER PANEL (collection) ------------------------ */
  function initFilter(){
    var btn=$("[data-filter-toggle]");
    var panel=$("[data-filter-panel]");
    if(!btn||!panel)return;
    on(btn,"click",function(){
      var willOpen=panel.hasAttribute("hidden");
      if(willOpen)panel.removeAttribute("hidden");else panel.setAttribute("hidden","");
      btn.setAttribute("aria-expanded",willOpen?"true":"false");
      btn.classList.toggle("is-open",willOpen);
    });
  }

  /* ---- COLLECTION: sort placement + refine-by open state by viewport ---- */
  function initCollControls(){
    var mq=window.matchMedia("(max-width:760px)");
    var sortWrap=$(".coll__sortwrap"),panel=$("[data-filter-panel]"),bar=$(".coll__bar");
    var navD=$(".coll__nav-d");
    function placeSort(){
      if(!sortWrap||!panel||!bar)return;
      if(mq.matches){if(sortWrap.parentNode!==panel)panel.insertBefore(sortWrap,panel.firstChild);}
      else if(sortWrap.parentNode===panel){bar.appendChild(sortWrap);}
    }
    function syncNav(){
      if(!navD)return;
      if(mq.matches)navD.removeAttribute("open");else navD.setAttribute("open","");
    }
    placeSort();syncNav();
    var onChange=function(){placeSort();syncNav();};
    if(mq.addEventListener)mq.addEventListener("change",onChange);
    else if(mq.addListener)mq.addListener(onChange);
  }

  /* ---- ON SALE refine (client-side, works with infinite scroll) ---- */
  function initOnsale(){
    var btn=$("[data-onsale-toggle]");
    var grid=$("[data-product-grid]");
    if(!grid)return;
    var countEl=$("[data-shown-count]");
    function updateCount(){
      if(!countEl)return;
      var active=grid.classList.contains("onsale-active");
      var n=0;
      grid.querySelectorAll(".object").forEach(function(c){
        if(!active||c.getAttribute("data-onsale")==="true")n++;
      });
      countEl.textContent=n+" objects";
    }
    function apply(active){
      grid.classList.toggle("onsale-active",active);
      if(btn){btn.setAttribute("aria-pressed",active?"true":"false");btn.classList.toggle("is-on",active);}
      var url=new URL(window.location);
      if(active)url.searchParams.set("onsale","1");else url.searchParams.delete("onsale");
      history.replaceState({},"",url);
      updateCount();
    }
    if(btn)on(btn,"click",function(){apply(!grid.classList.contains("onsale-active"));});
    document.addEventListener("krave:gridupdated",updateCount);
    var params=new URLSearchParams(window.location.search);
    if(params.get("onsale")==="1"&&btn)apply(true);else updateCount();
  }

  /* ---- 6. QUICK ADD (collection cards) ------------------- */
  function bindQuickAdd(){
    $$("[data-quick-add]:not([data-bound])").forEach(function(form){
      form.dataset.bound="1";
      on(form,"submit",function(e){
        e.preventDefault();
        var id=form.querySelector('[name="id"]').value;
        var btn=form.querySelector('[type="submit"]');
        if(!id){window.location=form.dataset.url;return;}
        Cart.add(id,1,btn);
      });
    });
  }

  /* ---- 7. TERMINAL NEWSLETTER ---------------------------- */
  // carries the {% form 'customer' %} + URLSearchParams pattern.
  function initNewsletter(){
    $$("[data-newsletter]").forEach(function(box){
      var form=box.querySelector("form");
      var msg=box.querySelector(".terminal__msg");
      var input=box.querySelector('input[type="email"]');
      if(!form)return;
      on(form,"submit",function(e){
        e.preventDefault();
        var val=(input.value||"").trim();
        if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)){
          box.classList.add("is-error");if(msg)msg.textContent="// invalid address";
          setTimeout(function(){box.classList.remove("is-error");},500);return;
        }
        fetch(form.action,{method:"POST",headers:{"Accept":"application/json"},body:new URLSearchParams(new FormData(form))})
          .then(function(){
            if(msg){msg.textContent="// on the list. drops land here first.";msg.classList.add("ok");}
            form.reset();
          }).catch(function(){
            if(msg)msg.textContent="// could not connect. try again.";
          });
      });
    });
  }

  /* ---- 8. NARRATIVE ENGINE (homepage as one document) ---- */
  /* Restrained cinematic: spine + bg journey + wordmark handoff,
     scroll-driven colour reveal, lookbook parallax, pinned doctrine.
     Everything degrades on reduced-motion and narrow viewports. */
  function initNarrative(){
    var spine=$("[data-spine]");
    if(!spine)return; /* homepage only */

    var reduce=window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var narrow=window.matchMedia("(max-width: 760px)").matches;

    var fileEl=$("[data-spine-file]");
    var progEl=$("[data-spine-progress]");
    var pageBg=$("[data-page-bg]");
    var heroMark=$("[data-hero-mark]");
    var heroFades=$$("[data-hero-fade]");
    var homeLogo=$("[data-home-logo]");
    var coldOpen=$(".cold-open");
    var reveals=$$("[data-colour-reveal]");
    var parallax=$$("[data-parallax]");
    var movements=$$("[data-movement]");

    var BG={ void:"#050505", ash:"#0b0b0b", campaign:"#141414" };

    /* spine file index + bg journey via IntersectionObserver */
    if("IntersectionObserver" in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            var f=e.target.getAttribute("data-file");
            if(f&&fileEl)fileEl.textContent=f;
            var bg=e.target.getAttribute("data-bg");
            if(bg&&pageBg)pageBg.style.background=BG[bg]||BG.void;
          }
        });
      },{rootMargin:"-45% 0px -45% 0px",threshold:0});
      movements.forEach(function(m){io.observe(m);});

      /* retire the spine once the footer is reached: it has done its job */
      var foot=document.querySelector(".site-foot");
      if(foot){
        var fo=new IntersectionObserver(function(entries){
          entries.forEach(function(e){spine.classList.toggle("is-docked",e.isIntersecting);});
        },{rootMargin:"0px 0px 40px 0px",threshold:0});
        fo.observe(foot);
      }
    }

    /* reveal header logo once past the cold open */
    if(coldOpen&&homeLogo&&"IntersectionObserver" in window){
      var hi=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          document.documentElement.classList.toggle("home-scrolled",!e.isIntersecting);
        });
      },{rootMargin:"-70% 0px 0px 0px",threshold:0});
      hi.observe(coldOpen);
    }

    var docH=function(){return Math.max(document.body.scrollHeight,document.documentElement.scrollHeight);};

    function frame(){
      var y=window.pageYOffset||document.documentElement.scrollTop;
      var vh=window.innerHeight;

      /* spine progress */
      if(progEl){
        var max=docH()-vh;
        var p=max>0?Math.min(1,Math.max(0,y/max)):0;
        progEl.style.transform="scaleY("+p+")";
      }

      if(!reduce){
        /* cold open: wordmark settles, copy lifts as you enter */
        if(coldOpen&&heroMark){
          var hp=Math.min(1,Math.max(0,y/(vh*0.9)));
          if(!narrow){
            heroMark.style.transform="translateY("+(-hp*40)+"px) scale("+(1-hp*0.12)+")";
          }
          heroMark.style.opacity=(1-hp*0.85).toFixed(3);
          heroFades.forEach(function(el){el.style.opacity=(1-hp*1.4).toFixed(3);});
        }

        /* lookbook parallax */
        if(!narrow){
          parallax.forEach(function(img){
            var r=img.getBoundingClientRect();
            var off=(r.top+r.height/2-vh/2)/vh;
            img.style.transform="translate3d(0,"+(off*-7).toFixed(2)+"%,0) scale(1.12)";
          });
        }

        /* scroll-driven black-and-white to colour on the lead object */
        reveals.forEach(function(el){
          var r=el.getBoundingClientRect();
          var rp=1-Math.min(1,Math.max(0,(r.top-vh*0.2)/(vh*0.6)));
          el.style.setProperty("--reveal",rp.toFixed(3));
        });
      }

      ticking=false;
    }

    var ticking=false;
    function onScroll(){
      if(!ticking){ticking=true;requestAnimationFrame(frame);}
    }
    window.addEventListener("scroll",onScroll,{passive:true});
    window.addEventListener("resize",function(){
      narrow=window.matchMedia("(max-width: 760px)").matches;
      onScroll();
    },{passive:true});
    frame();
  }

  /* ---- 9. EDITORIAL REVEALS (every page) ----------------- */
  function initReveals(){
    var els=$$("[data-reveal]");
    if(!els.length)return;
    if(!("IntersectionObserver" in window)){els.forEach(function(el){el.classList.add("in");});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}
      });
    },{rootMargin:"0px 0px -10% 0px",threshold:0.08});
    els.forEach(function(el){io.observe(el);});
  }

  /* ---- EMAIL POPUP (multi-trigger, frequency) ----------- */
  function initPopup(){
    var pop=$("[data-popup]");
    var editor=window.Shopify&&window.Shopify.designMode;
    function show(p){if(!p)return;p.removeAttribute("hidden");requestAnimationFrame(function(){p.classList.add("is-open");});}
    function hide(p){if(!p)return;p.classList.remove("is-open");setTimeout(function(){p.setAttribute("hidden","");},300);}
    // Editor: preview the popup when its section is selected or edited. No live triggers.
    if(editor){
      if(!document.__kpopupBound){
        document.__kpopupBound=true;
        var sel=function(e){var p=e.target.querySelector&&e.target.querySelector("[data-popup]");if(p)show(p);};
        var des=function(e){var p=e.target.querySelector&&e.target.querySelector("[data-popup]");if(p)hide(p);};
        document.addEventListener("shopify:section:select",sel);
        document.addEventListener("shopify:section:load",sel);
        document.addEventListener("shopify:section:deselect",des);
      }
      if(pop)$$("[data-popup-close]",pop).forEach(function(b){on(b,"click",function(){hide(pop);});});
      return;
    }
    if(!pop)return;
    var freq=pop.getAttribute("data-frequency");
    var days=parseInt(pop.getAttribute("data-days"),10)||14;
    var key="krave_popup_seen";
    function seen(){
      try{
        if(freq==="always")return false;
        if(freq==="session")return sessionStorage.getItem(key)==="1";
        var ts=parseInt(localStorage.getItem(key),10);
        if(!ts)return false;
        return (Date.now()-ts)<days*864e5;
      }catch(e){return false;}
    }
    function mark(){
      try{
        if(freq==="session")sessionStorage.setItem(key,"1");
        else localStorage.setItem(key,String(Date.now()));
      }catch(e){}
    }
    function open(){if(pop.classList.contains("is-open"))return;show(pop);mark();}
    function close(){hide(pop);}
    $$("[data-popup-close]",pop).forEach(function(b){on(b,"click",close);});
    on(document,"keydown",function(e){if(e.key==="Escape"&&pop.classList.contains("is-open"))close();});
    if(seen())return;
    var trig=pop.getAttribute("data-trigger");
    if(trig==="load"){open();}
    else if(trig==="delay"){setTimeout(open,(parseInt(pop.getAttribute("data-delay"),10)||6)*1000);}
    else if(trig==="scroll"){
      var depth=(parseInt(pop.getAttribute("data-scroll"),10)||40)/100;
      var h=function(){
        var sc=(window.pageYOffset)/(document.body.scrollHeight-window.innerHeight||1);
        if(sc>=depth){open();window.removeEventListener("scroll",h);}
      };
      window.addEventListener("scroll",h,{passive:true});
    } else if(trig==="exit"){
      var ex=function(e){if(e.clientY<=0){open();document.removeEventListener("mouseout",ex);}};
      document.addEventListener("mouseout",ex);
      setTimeout(open,45000);
    }
  }

  /* ---- COOKIE CONSENT ----------------------------------- */
  function initCookie(){
    var bar=$("[data-cookie]");
    if(!bar)return;
    var key="krave_cookie";
    function show(){bar.removeAttribute("hidden");requestAnimationFrame(function(){bar.classList.add("is-open");});}
    function hide(){bar.classList.remove("is-open");setTimeout(function(){bar.setAttribute("hidden","");},300);}
    function bind(apply){
      var a=$("[data-cookie-accept]",bar),r=$("[data-cookie-reject]",bar);
      if(a)on(a,"click",function(){apply(true);hide();});
      if(r)on(r,"click",function(){apply(false);hide();});
    }
    function remember(ok){try{localStorage.setItem(key,ok?"all":"essential");}catch(e){}}
    // Editor: just preview the bar so it can be styled.
    if(window.Shopify&&window.Shopify.designMode){bind(function(){});show();return;}
    function fallback(){
      // Privacy API unavailable: remember choice locally, show once.
      bind(remember);
      var choice=null;try{choice=localStorage.getItem(key);}catch(e){}
      if(!choice)show();
    }
    function withAPI(cp){
      bind(function(ok){
        remember(ok);
        try{
          cp.setTrackingConsent({analytics:ok,marketing:ok,preferences:ok,sale_of_data:ok},function(){});
        }catch(e){
          try{cp.setTrackingConsent(ok,function(){});}catch(e2){}
        }
      });
      var need=true;
      try{if(typeof cp.shouldShowBanner==="function")need=cp.shouldShowBanner();}catch(e){}
      if(need)show();
    }
    if(window.Shopify&&typeof window.Shopify.loadFeatures==="function"){
      Shopify.loadFeatures([{name:"consent-tracking-api",version:"0.1"}],function(err){
        if(!err&&window.Shopify&&Shopify.customerPrivacy){withAPI(Shopify.customerPrivacy);}
        else{fallback();}
      });
    }else if(window.Shopify&&window.Shopify.customerPrivacy){
      withAPI(Shopify.customerPrivacy);
    }else{
      fallback();
    }
  }

  /* ---- PRELOADER ---------------------------------------- */
  function initPreloader(){
    var pl=$("[data-preloader]");
    if(!pl)return;
    var done=function(){pl.classList.add("is-done");setTimeout(function(){if(pl.parentNode)pl.parentNode.removeChild(pl);},700);};
    if(document.readyState==="complete")setTimeout(done,400);
    else window.addEventListener("load",function(){setTimeout(done,400);});
    setTimeout(done,4000);
  }

  /* ---- PRODUCT CAROUSEL --------------------------------- */
  function initCarousel(){
    $$("[data-pcar-track]").forEach(function(track){
      var sec=track.closest("section");if(!sec)return;
      var prev=$("[data-pcar-prev]",sec),next=$("[data-pcar-next]",sec);
      function step(){var c=track.querySelector(".pcar__cell");return c?c.getBoundingClientRect().width+24:300;}
      if(prev)on(prev,"click",function(){track.scrollBy({left:-step()*2,behavior:"smooth"});});
      if(next)on(next,"click",function(){track.scrollBy({left:step()*2,behavior:"smooth"});});
    });
  }

  /* ---- PREDICTIVE SEARCH (inline, no page change) ------- */
  function initSearch(){
    var wrap=$("[data-search]");
    if(!wrap)return;
    var input=$("[data-search-input]",wrap);
    var results=$("[data-search-results]",wrap);
    function open(){
      wrap.removeAttribute("hidden");
      requestAnimationFrame(function(){wrap.classList.add("is-open");});
      setTimeout(function(){if(input)input.focus();},140);
    }
    function close(){wrap.classList.remove("is-open");setTimeout(function(){wrap.setAttribute("hidden","");},260);}
    $$("[data-search-open]").forEach(function(b){on(b,"click",function(e){e.preventDefault();open();});});
    $$("[data-search-close]",wrap).forEach(function(b){on(b,"click",close);});
    on(document,"keydown",function(e){if(e.key==="Escape"&&wrap.classList.contains("is-open"))close();});
    if(!input||!results)return;
    function esc(x){return (x||"").replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});}
    function render(data){
      var r=(data.resources&&data.resources.results)||{};
      var prods=r.products||[],colls=r.collections||[],arts=r.articles||[],pages=r.pages||[];
      var html="";
      if(prods.length){
        html+='<div class="ksearch__group"><span class="ksearch__gl label">Objects</span>';
        prods.forEach(function(p){
          var img=(p.featured_image&&p.featured_image.url)||p.image||"";
          html+='<a class="ksearch__item" href="'+p.url+'">'+
            '<span class="ksearch__thumb">'+(img?'<img src="'+img+'" alt="" loading="lazy">':'')+'</span>'+
            '<span class="ksearch__it-title">'+esc(p.title)+'</span>'+
            '<span class="ksearch__it-price">'+(p.price||"")+'</span></a>';
        });
        html+='</div>';
      }
      if(colls.length){html+='<div class="ksearch__group"><span class="ksearch__gl label">Collections</span>';colls.forEach(function(c){html+='<a class="ksearch__row" href="'+c.url+'">'+esc(c.title)+'</a>';});html+='</div>';}
      if(arts.length){html+='<div class="ksearch__group"><span class="ksearch__gl label">Journal</span>';arts.forEach(function(a){html+='<a class="ksearch__row" href="'+a.url+'">'+esc(a.title)+'</a>';});html+='</div>';}
      if(pages.length){html+='<div class="ksearch__group"><span class="ksearch__gl label">Pages</span>';pages.forEach(function(pg){html+='<a class="ksearch__row" href="'+pg.url+'">'+esc(pg.title)+'</a>';});html+='</div>';}
      if(!prods.length&&!colls.length&&!arts.length&&!pages.length)html='<p class="ksearch__empty label">// no objects found</p>';
      results.innerHTML=html;
    }
    var t,last="";
    function query(q){
      var url="/search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last";
      fetch(url,{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(render).catch(function(){});
    }
    on(input,"input",function(){
      var q=input.value.trim();
      clearTimeout(t);
      if(q.length<2){results.innerHTML="";last="";return;}
      if(q===last)return;last=q;
      t=setTimeout(function(){query(q);},220);
    });
  }

  /* ---- COUNTDOWN (drop timer) --------------------------- */
  function initCountdown(){
    $$("[data-countdown]").forEach(function(el){
      var target=el.getAttribute("data-target");if(!target)return;
      var end=new Date(target).getTime();if(isNaN(end))return;
      var clock=$("[data-countdown-clock]",el),done=$("[data-countdown-done]",el);
      var d=$('[data-cd="days"]',el),h=$('[data-cd="hours"]',el),m=$('[data-cd="mins"]',el),s=$('[data-cd="secs"]',el);
      function pad(n){return (n<10?"0":"")+n;}
      var t=setInterval(tick,1000);
      function tick(){
        var diff=end-Date.now();
        if(diff<=0){if(clock)clock.style.display="none";if(done)done.removeAttribute("hidden");clearInterval(t);return;}
        if(d)d.textContent=pad(Math.floor(diff/864e5));
        if(h)h.textContent=pad(Math.floor(diff%864e5/36e5));
        if(m)m.textContent=pad(Math.floor(diff%36e5/6e4));
        if(s)s.textContent=pad(Math.floor(diff%6e4/1e3));
      }
      tick();
    });
  }

  /* ---- SHOPPABLE IMAGE (hotspots) ----------------------- */
  function initShoppable(){
    // lock card position so it never spills outside the frame
    $$(".shop-hotspot").forEach(function(spot){
      var x=parseFloat(spot.style.left)||50;
      var y=parseFloat(spot.style.top)||50;
      if(x<22)spot.classList.add("edge-left");
      else if(x>78)spot.classList.add("edge-right");
      if(y<26)spot.classList.add("edge-bottom");
    });
    function closeAll(root){
      var sc=root||document;
      $$("[data-hotspot]",sc).forEach(function(x){x.classList.remove("is-open");});
      $$("[data-hotspot-card]",sc).forEach(function(c){c.classList.remove("is-open");});
    }
    $$("[data-hotspot]").forEach(function(dot){
      on(dot,"click",function(e){
        e.preventDefault();e.stopPropagation();
        var root=dot.closest("[data-shoppable]");
        var spot=dot.parentNode;
        var card=spot.querySelector("[data-hotspot-card]");
        var open=dot.classList.contains("is-open");
        closeAll(root);
        if(!open){dot.classList.add("is-open");if(card)card.classList.add("is-open");}
      });
    });
    on(document,"click",function(e){
      if(!e.target.closest(".shop-hotspot"))closeAll(null);
    });
  }

  /* ---- EXPANDING PANELS --------------------------------- */
  function initPanels(){
    $$("[data-panels]").forEach(function(root){
      var panels=$$("[data-panel]",root);
      panels.forEach(function(p){
        on(p,"click",function(){
          panels.forEach(function(x){x.classList.remove("is-active");});
          p.classList.add("is-active");
        });
      });
    });
  }

  /* ---- QUOTE / PRESS ROTATOR ---------------------------- */
  function initQuotes(){
    $$("[data-quotes]").forEach(function(root){
      var items=$$("[data-quote]",root);
      if(items.length<2)return;
      var i=0,iv=parseInt(root.getAttribute("data-interval"),10)||6000;
      setInterval(function(){
        items[i].classList.remove("is-active");
        i=(i+1)%items.length;
        items[i].classList.add("is-active");
      },iv);
    });
  }

  /* ---- boot ---------------------------------------------- */
  function setHeadHeight(){
    var h=$(".site-head");
    if(h)document.documentElement.style.setProperty("--head-h",h.offsetHeight+"px");
  }
  if(!document.__kraveHeadResize){
    document.__kraveHeadResize=true;
    window.addEventListener("resize",setHeadHeight,{passive:true});
    window.addEventListener("load",setHeadHeight);
  }

  function boot(){
    setHeadHeight();
    initMarquee();initNav();initCart();initVariants();initInfinite();bindQuickAdd();initNewsletter();initNarrative();initReveals();initFilter();initOnsale();initPopup();initCookie();initPreloader();initCarousel();initSearch();initCountdown();initShoppable();initPanels();initQuotes();
  }
  if(document.readyState!=="loading")boot();else document.addEventListener("DOMContentLoaded",boot);

  // re-run on Shopify section editor events
  document.addEventListener("shopify:section:load",boot);
})();
